/**
 * The last frame of the former `hero-home.json` Lottie, flattened: each path sits at its `at` offset. The
 * sleeves run 40 units further below the artboard than drawn, so a hand lifting past its coin shows no cuff end.
 */
export type ArtPath = { d: string; at?: string; fill?: boolean; cap?: 'butt'; join?: 'miter' };

/** Left to right, each hand with the coin it lifts. */
export const HANDS: readonly { hand: readonly ArtPath[]; coin: readonly ArtPath[] }[] = [
	{
		hand: [
			{
				d: 'M-1.9,159.2 C1.6,162.1 15,170.3 45.1,159 C46,158.6 46.7,157.7 46.7,156.7 C46.7,156.7 46.7,2.5 46.7,2.5 C46.7,0.6 44.6,-0.7 43,0.3 C38,3.3 27.7,7.1 11,2.8 C9.5,2.4 8,3.5 7.9,5 C7.9,5 -2.8,157.1 -2.8,157.1 C-2.9,157.9 -2.5,158.7 -1.9,159.2 C-1.9,159.2 -1.9,159.2 -1.9,159.2 C-1.9,159.2 -1.9,159.2 -1.9,159.2z',
				at: '102 219.61',
				cap: 'butt',
			},
			{
				d: 'M0.4,129.1 C0.4,129.1 -8.1,23 53.7,0.2 C54.8,-0.2 56.2,-0.1 57.1,0.7 C59.1,2.3 59.6,6.6 43.8,17.5 C43.8,17.5 61.8,4.2 65,11.2 C67.5,16.6 49.7,26.2 49.7,26.2 C49.7,26.2 62.7,18.4 65.7,23.5 C69.2,29.3 54.5,36.4 54.5,36.4 C54.5,36.4 64.8,30.4 67.8,34.9 C69.7,37.8 67.1,41.4 58.2,46.5 C45.6,53.7 30.8,66.4 30.8,126.8',
				at: '112.66 93.25',
			},
		],
		coin: [
			{
				d: 'M6.5,34.7 C-7.5,21.5 2.9,-1.6 22.4,0.1 C30.8,0.8 39.2,9 40,17.5 C41.8,36.2 20.3,47.7 6.5,34.7 C6.5,34.7 6.5,34.7 6.5,34.7 C6.5,34.7 6.5,34.7 6.5,34.7z',
				at: '126.88 60.28',
				fill: true,
			},
			{ d: 'M9.5,0 C9.5,0 -1.8,2.4 0.2,13.2 C2.1,23.1 11.8,23.4 16.8,19.4', at: '139.2 68.83' },
			{ d: 'M0,4.5 C0,4.5 13.5,0 13.5,0', at: '135.31 77.17', join: 'miter' },
			{ d: 'M0,4.5 C0,4.5 13.5,0 13.5,0', at: '137.18 82.18', join: 'miter' },
		],
	},
	{
		hand: [
			{
				d: 'M0,3.2 C0,3.2 0,161.5 0,161.5 C0,161.5 9.2,169.3 26.5,167 C43.8,164.7 49.3,160.6 49.3,160.6 C49.3,160.6 49.3,0 49.3,0 C49.3,0 0,3.2 0,3.2 C0,3.2 0,3.2 0,3.2 C0,3.2 0,3.2 0,3.2z',
				at: '203.97 243.71',
				cap: 'butt',
			},
			{
				d: 'M5.2,20.6 C5.2,20.6 1.2,22.8 0.7,15.5 C0.2,8.2 -2.5,0 8,0 C8,0 52.2,0 52.2,0 C52.2,0 57.6,0.5 58.1,4.6 C58.6,8.7 61.4,17 54.5,17.4 C47.6,17.8 5.2,20.6 5.2,20.6 C5.2,20.6 5.2,20.6 5.2,20.6 C5.2,20.6 5.2,20.6 5.2,20.6z',
				at: '198.75 226.35',
				cap: 'butt',
			},
			{ d: 'M49.3,0 C49.3,0 0,0 0,0', at: '203.97 261.99', join: 'miter' },
			{ d: 'M49.1,0 C49.1,0 0,3.7 0,3.7', at: '204.04 278.84', join: 'miter' },
			{ d: 'M49.1,0 C49.1,0 0,3.7 0,3.7', at: '204.04 305.55', join: 'miter' },
			{ d: 'M49.3,0 C49.3,0 0,0.1 0,0.1', at: '203.97 290.28', join: 'miter' },
			{ d: 'M49.3,0 C49.3,0 0,0.1 0,0.1', at: '203.97 327.75', join: 'miter' },
			{
				d: 'M52.2,63.3 C52.2,63.3 58.6,21.6 49.5,18.9 C45.1,17.6 43.4,29.9 43.4,29.9 C43.4,29.9 43.5,11.7 36,11.5 C28.5,11.3 29.6,28.1 29.6,28.1 C28.9,11 25.9,-1.6 19.4,0.2 C12.9,2 17.1,20.9 17.1,20.9 C19.5,38.4 18.5,44.4 15.6,42.2 C12.1,39.5 10.7,25.6 5.4,25.3 C-6.7,24.5 5.4,63.3 5.4,63.3',
				at: '198.66 163.02',
			},
			{ d: 'M49.3,0 C49.3,0 0,0.1 0,0.1', at: '203.97 345', join: 'miter' },
		],
		coin: [
			{
				d: 'M6.1,32.9 C-7.2,20.4 2.7,-1.5 21.2,0.1 C29.2,0.8 37.3,8.6 38.1,16.6 C39.8,34.4 19.3,45.2 6.1,32.9 C6.1,32.9 6.1,32.9 6.1,32.9 C6.1,32.9 6.1,32.9 6.1,32.9z',
				at: '175.78 151.96',
				fill: true,
			},
			{ d: 'M8.8,0 C8.8,0 -1.7,2.3 0.2,12.2 C1.9,21.3 10.9,21.6 15.5,17.9', at: '187.94 160.54' },
			{ d: 'M0,4.2 C0,4.2 12.4,0 12.4,0', at: '184.35 168.23', join: 'miter' },
			{ d: 'M0,4.2 C0,4.2 12.4,0 12.4,0', at: '185.7 173.22', join: 'miter' },
		],
	},
	{
		hand: [
			{
				d: 'M0,3.3 C0,3.3 45.7,0 45.7,0 C45.7,0 69.8,153.3 69.8,153.3 C69.8,153.3 64.5,161.9 48,162.6 C31.5,163.3 24.2,157.3 24.2,157.3 C24.2,157.3 0,3.3 0,3.3 C0,3.3 0,3.3 0,3.3 C0,3.3 0,3.3 0,3.3z',
				at: '288.06 223.91',
				cap: 'butt',
			},
			{
				d: 'M30.2,115.7 C30.2,115.7 22.5,67.7 22.5,67.7 C22.2,65.7 21.3,63.9 19.8,62.5 C14.3,57.2 0.5,42.2 0,24.9 C0,24.6 0,24.4 0,24.1 C0.1,21.7 1.1,10.6 7.3,9.5 C12.6,8.6 12.2,15.1 11.7,18.3 C11.4,20.1 11.6,22 12.4,23.7 C13.4,25.7 15.3,27.3 18.8,25.3 C25.4,21.4 22.9,16 18,11.6 C16,9.8 9,8.4 12.5,2.4 C16,-3.6 35.1,1.6 37.4,19.3',
				at: '262.32 111.13',
			},
			{ d: 'M0.2,7 C0.2,7 -1.9,-0.2 7.5,0 C16.8,0.2 23.8,13.8 23.6,27.6', at: '284.22 104.16' },
			{
				d: 'M0,0 C0,0 12.5,0.5 11.5,11.8 C10.5,22.6 10.6,21.5 10.6,21.5 C10.6,21.5 17.5,6.9 23.8,8.3 C30.1,9.7 17.8,28.1 17.8,28.1 C17.8,28.1 13.2,58.6 13.2,58.6 C13.2,58.6 25.6,111.5 25.6,111.5',
				at: '303.5 112.45',
			},
			{ d: 'M0,4 C0,4 28.7,1.5 28.7,1.5 C28.7,1.5 45.9,0 45.9,0', at: '291.28 245.7' },
			{ d: 'M24.2,138.1 C24.2,138.1 0,0 0,0', at: '319.95 247.21', join: 'miter' },
			{ d: 'M0,0 C0,0 24,136.5 24,136.5', at: '299.69 249', join: 'miter' },
			{ d: 'M0,5.6 C0,5.6 45.3,0 45.3,0', at: '294.73 264.19', join: 'miter' },
			{ d: 'M0,5.6 C0,5.6 44.5,0 44.5,0', at: '300.5 300.51', join: 'miter' },
			{ d: 'M0,5.6 C0,5.6 45.3,0 45.3,0', at: '303.57 320.59', join: 'miter' },
			{ d: 'M0,5.6 C0,5.6 45.3,0 45.3,0', at: '306.6 340.6', join: 'miter' },
			{ d: 'M0,2.8 C0,2.8 45.1,0 45.1,0', at: '297.94 283.23', join: 'miter' },
		],
		coin: [
			{
				d: 'M17,37.8 C-1.2,35.9 -6.4,12.4 9.3,2.5 C16.1,-1.8 27.3,-0.4 32.7,5.6 C44.8,18.8 34.9,39.7 17,37.8 C17,37.8 17,37.8 17,37.8z',
				at: '238.75 85.56',
				fill: true,
			},
			{ d: 'M9.5,0 C9.5,0 -1.8,2.4 0.2,13.2 C2.1,23.1 11.8,23.4 16.8,19.4', at: '249.1 92.94' },
			{ d: 'M0,4.5 C0,4.5 13.5,0 13.5,0', at: '245.2 101.27', join: 'miter' },
			{ d: 'M0,4.5 C0,4.5 13.5,0 13.5,0', at: '246.66 106.69', join: 'miter' },
		],
	},
];
